(() => {
  const openMenu = () => {
    const menu = document.querySelector('[data-pe-mobile-menu]');
    if (!menu) return;

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pe-menu-open');
  };

  const closeMenu = () => {
    const menu = document.querySelector('[data-pe-mobile-menu]');
    if (!menu) return;

    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pe-menu-open');
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-pe-menu-open]');
    const closeButton = event.target.closest('[data-pe-menu-close]');
    const menuLink = event.target.closest('[data-pe-menu-link]');

    if (openButton) {
      openMenu();
      return;
    }

    if (closeButton || menuLink) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-pe-variant-select]');
    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];
    const card = select.closest('[data-pe-product-card]');
    if (!selectedOption || !card) return;

    const price = card.querySelector('[data-pe-product-price]');
    const productForm = card.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
    const addButton = productForm ? productForm.querySelector('[type="submit"]') : null;

    if (price) {
      price.textContent = selectedOption.dataset.price || price.textContent;
    }

    if (variantInput) {
      variantInput.value = selectedOption.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (addButton) {
      const available = selectedOption.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available
        ? addButton.dataset.availableText || 'Ajouter au panier'
        : addButton.dataset.soldOutText || 'Épuisé';
    }
  });

  const formatNumber = (value) => {
    return new Intl.NumberFormat('fr-FR').format(Math.round(value));
  };

  const formatEuro = (value) => {
    return new Intl.NumberFormat('fr-FR').format(Math.round(value)) + ' €';
  };

  const calculateTierPrice = (basePrice, quantity) => {
    if (quantity >= 20000) return basePrice * 0.74;
    if (quantity >= 5000) return basePrice * 0.86;
    return basePrice;
  };

  const updateCalculator = (calculator) => {
    const surfaceInput = calculator.querySelector('[data-pe-calc-surface]');
    const goalSelect = calculator.querySelector('[data-pe-calc-goal]');
    const serviceSelect = calculator.querySelector('[data-pe-calc-service]');

    if (!surfaceInput || !goalSelect || !serviceSelect) return;

    const selectedGoal = goalSelect.options[goalSelect.selectedIndex];
    const selectedService = serviceSelect.options[serviceSelect.selectedIndex];

    const hectares = Number(surfaceInput.value || 1);
    const density = Number(selectedGoal.dataset.density || 600);
    const basePrice = Number(selectedGoal.dataset.basePrice || 4.2);
    const volumePerPlant = Number(selectedGoal.dataset.volumePerPlant || 0.45);
    const servicePricePerHa = Number(selectedService.dataset.pricePerHa || 0);
    const buybackPrice = Number(calculator.dataset.buybackPrice || 150);

    const plants = hectares * density;
    const unitPrice = calculateTierPrice(basePrice, plants);
    const plantsCost = plants * unitPrice;
    const serviceCost = hectares * servicePricePerHa;
    const estimatedVolume = plants * volumePerPlant;
    const totalBudget = plantsCost + serviceCost;
    const estimatedRevenue = estimatedVolume * buybackPrice;

    const surfaceValue = calculator.querySelector('[data-pe-calc-surface-value]');
    const plantsValue = calculator.querySelector('[data-pe-calc-plants]');
    const unitValue = calculator.querySelector('[data-pe-calc-unit]');
    const plantsCostValue = calculator.querySelector('[data-pe-calc-plants-cost]');
    const serviceCostValue = calculator.querySelector('[data-pe-calc-service-cost]');
    const volumeValue = calculator.querySelector('[data-pe-calc-volume]');
    const totalValue = calculator.querySelector('[data-pe-calc-total]');
    const revenueValue = calculator.querySelector('[data-pe-calc-revenue]');

    if (surfaceValue) surfaceValue.textContent = formatNumber(hectares);
    if (plantsValue) plantsValue.textContent = formatNumber(plants);
    if (unitValue) unitValue.textContent = unitPrice.toFixed(2).replace('.', ',') + ' €';
    if (plantsCostValue) plantsCostValue.textContent = formatEuro(plantsCost);
    if (serviceCostValue) serviceCostValue.textContent = formatEuro(serviceCost);
    if (volumeValue) volumeValue.textContent = formatNumber(estimatedVolume) + ' m³';
    if (totalValue) totalValue.textContent = formatEuro(totalBudget);
    if (revenueValue) revenueValue.textContent = formatEuro(estimatedRevenue);
  };

  document.querySelectorAll('[data-pe-calculator]').forEach((calculator) => {
    calculator.querySelectorAll('input, select').forEach((field) => {
      field.addEventListener('input', () => updateCalculator(calculator));
      field.addEventListener('change', () => updateCalculator(calculator));
    });

    updateCalculator(calculator);
  });

  const closeMegaMenu = () => {
    const item = document.querySelector('[data-pe-mega-item]');
    if (!item) return;

    const link = item.querySelector('[data-pe-mega-link]');
    item.classList.remove('is-open');

    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }
  };

  const openMegaMenu = () => {
    const item = document.querySelector('[data-pe-mega-item]');
    if (!item) return;

    const link = item.querySelector('[data-pe-mega-link]');
    item.classList.add('is-open');

    if (link) {
      link.setAttribute('aria-expanded', 'true');
    }
  };

  const toggleMegaMenu = (event) => {
    const item = event.target.closest('[data-pe-mega-item]');
    if (!item) return;

    event.preventDefault();

    if (item.classList.contains('is-open')) {
      closeMegaMenu();
    } else {
      openMegaMenu();
    }
  };

  let megaCloseTimer;

  document.addEventListener('mouseover', (event) => {
    const item = event.target.closest('[data-pe-mega-item]');
    if (!item || window.innerWidth < 1040) return;

    window.clearTimeout(megaCloseTimer);
    openMegaMenu();
  });

  document.addEventListener('mouseout', (event) => {
    const item = event.target.closest('[data-pe-mega-item]');
    if (!item || window.innerWidth < 1040) return;

    if (item.contains(event.relatedTarget)) return;

    megaCloseTimer = window.setTimeout(closeMegaMenu, 120);
  });

  document.addEventListener('click', (event) => {
    const megaLink = event.target.closest('[data-pe-mega-link]');
    const mobileAccordionToggle = event.target.closest('[data-pe-mobile-accordion-toggle]');
    const megaItem = event.target.closest('[data-pe-mega-item]');

    if (megaLink) {
      toggleMegaMenu(event);
      return;
    }

    if (mobileAccordionToggle) {
      const accordion = mobileAccordionToggle.closest('[data-pe-mobile-accordion]');
      if (accordion) {
        accordion.classList.toggle('is-open');
      }
      return;
    }

    if (!megaItem) {
      closeMegaMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMegaMenu();
    }
  });
})();

